import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Company, Category, HTMLInputEvent } from '../../shared/models/v-builder.models';
import { MessageService } from '../../../shared/services/message/message.service';
import { Modalconfig } from '../../../shared/constants';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';

@Component({
    selector: 'app-v-builder-category-modal',
    templateUrl: './v-builder-category-modal.component.html',
    styleUrls: ['./v-builder-category-modal.component.scss'],
    standalone: false
})
export class VBuilderCategoryModalComponent {

  validImgExt = ['jpg', 'jpeg', 'png'];
  verb: string;
  uploadedImg: string | ArrayBuffer = '';
  companyList: Company[] = [];
  confirmationModalRef: BsModalRef;
  selectedCategory: Category;

  constructor(
    private modalRef: BsModalRef,
    private modalService: BsModalService,
    private commonHttpService: CommonHttpService,
    private messageService: MessageService
  ) { }

  /**
   * To set appropriate cover image src in category modal
   */
  getImageSrc() {
    if (this.uploadedImg) {
      return this.uploadedImg;
    } else if (this.selectedCategory && this.selectedCategory.iconAssetId) {
      // for edit mode
      return `/api/Assets/Image/${this.selectedCategory.iconAssetId}`;
    }
    return '';
  }

  /**
   * To process and to save uploaded image
   */
  imageSelected(event: HTMLInputEvent) {
    const selectedFile = event.target.files[0] as File;
    if (selectedFile) {
      const mimeType = selectedFile.type;
      if (mimeType.match(/image\/*/) != null && this.validImgExt.indexOf(mimeType.split('/').pop()) !== -1) {
        const formData = new FormData() as any;
        formData.append('file', selectedFile);
        this.commonHttpService.post(
          {
            uri: '/api/Assets/UploadImage',
            object: formData
          }).subscribe((response) => {
            const imgReader = new FileReader();
            imgReader.readAsDataURL(selectedFile);
            imgReader.onload = (e) => {
              this.uploadedImg = imgReader.result;
            };
            this.selectedCategory.iconAssetId = response['id'] || 0;
          });
      } else {
        this.messageService.showWarningMessage('Image type must be jpeg/jpg or png');
      }
    }
  }

  /**
   * To save new or edited category
   */
  saveCategory(verb: string) {
    const categoryData = {
      name: this.selectedCategory.name,
      iconAssetId: this.selectedCategory.iconAssetId,
      companyId: this.selectedCategory.companyId || null
    };
    if (verb === 'Add Category') {
      this.commonHttpService.post(
        {
          uri: '/api/VBuilder/AddCategory',
          object: categoryData,
          message: {
            successMessage: 'Category added successfully.',
          }
        }).subscribe((response) => {
          // setting modalref content to reflect added category in categoryList component
          this.modalRef.content.addedCategory = response;
          this.closeModal();
        });
    } else if (verb === 'Edit Category' && this.selectedCategory.id) {
      this.commonHttpService.put(
        {
          uri: '/api/VBuilder/UpdateCategory',
          object: {
            id: this.selectedCategory.id,
            ...categoryData
          },
          message: {
            successMessage: 'Category updated successfully.',
          }
        }).subscribe((response) => {
          // setting modalref content to reflect updated category in categoryList component
          this.modalRef.content.editedCategory = response;
          this.closeModal();
        });
    }
  }

  /**
   * To delete category
   */
  deleteCategory() {
    if (this.selectedCategory.id) {
      const initialState = {
        msg: `Removing this category will publish all client builders which are associated with this category.
        Are you sure want to delete this category?`
      };
      this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
        Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
      this.confirmationModalRef.content.onclose.subscribe((isDelete: boolean) => {
        if (isDelete) {
          this.commonHttpService.delete(
            {
              uri: '/api/VBuilder/DeleteCategory?categoryId=' + this.selectedCategory.id,
              message: {
                successMessage: 'Category deleted successfully.',
              }
            })
            .subscribe((response) => {
              // setting modalref content to reflect deleted category in categoryList component
              this.modalRef.content.deletedCgId = this.selectedCategory.id;
              this.closeModal();
            });
        }
        this.confirmationModalRef.hide();
      });
    }
  }

  openFileDialog() {
    document.getElementById('uploadPreviewImage').click();
  }

  removeImage() {
    this.uploadedImg = null;
    this.selectedCategory.iconAssetId = null;
  }

  closeModal() {
    this.modalRef.hide();
  }
}
